import gql from "graphql-tag";
import { invoiceFragment } from "./fragments";

export const GET_PROJECT_TO_INVOICE = gql`
  query getProjectsToInvoice(
    $upUntil: Date
    $filterBalance: FilterBalance
    $offset: Int
    $limit: Int
  ) {
    projectsToInvoice(
      upUntil: $upUntil
      filterBalance: $filterBalance
      offset: $offset
      limit: $limit
    ) {
      hasMore
      items {
        id
        ordersTotal
        timesheetInvoiced # for debugging
        totalExpensesNet
        totalUninvoicedOfferedNet
        hasUnvalidatedOfferedAmount
        performedTimesheetsTotal
        invoicedTotal
        toInvoice
        toInvoiceGross
        projectId
        projectName
        clientId
        clientName
        draftInvoice {
          id
          dueDate
          company {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_CLIENTS_TO_INVOICE = gql`
  query getClientsToInvoice(
    $upUntil: Date
    $filterBalance: FilterBalance
    $offset: Int
    $limit: Int
  ) {
    clientsToInvoice(
      upUntil: $upUntil
      filterBalance: $filterBalance
      offset: $offset
      limit: $limit
    ) {
      hasMore
      items {
        id
        clientId
        clientName
        ordersTotal
        performedTimesheetsTotal
        totalExpensesNet
        totalUninvoicedOfferedNet
        hasUnvalidatedOfferedAmount
        invoicedTotal
        toInvoice
        toInvoiceGross
        commentsCount
        projects {
          id
          ordersTotal
          timesheetInvoiced
          totalExpensesNet
          totalUninvoicedOfferedNet
          hasUnvalidatedOfferedAmount
          performedTimesheetsTotal
          invoicedTotal
          toInvoice
          toInvoiceGross
          projectId
          projectName
          clientId
          clientName
          draftInvoice {
            id
            dueDate
            company {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_COMPANIES = gql`
  query projectCompanies($id: ID!) {
    project(id: $id) {
      id
      client {
        companies {
          id
          name
        }
      }
    }
  }
`;

export const GET_INDEPENDENT_INVOICES = gql`
  query independentInvoices($offset: Int, $limit: Int) {
    independentInvoices(offset: $offset, limit: $limit) {
      hasMore
      items {
        ...InvoiceFragment
        date
        project {
          id
          name
        }
        company {
          id
          name
        }
      }
    }
  }
  ${invoiceFragment}
`;

export const GET_PROJECT_INVOICES = gql`
  query getProjectInvoices(
    $projectId: ID!
    $offset: Int
    $limit: Int
    $filter: InvoiceFilter
  ) {
    projectInvoices(
      projectId: $projectId
      offset: $offset
      limit: $limit
      filter: $filter
    ) {
      hasMore
      items {
        ...InvoiceFragment
        company {
          id
          name
          client {
            id
          }
        }
        linkedResource {
          ... on TimesheetsAsLinkedResource {
            startDate
            endDate
            project {
              name
            }
          }
          ... on Order {
            id
            startDate
            endDate
            paymentOption
            project {
              name
            }
          }
        }
      }
    }
  }
  ${invoiceFragment}
`;

export const GET_USER_INVOICES = gql`
  query getClientInvoices($offset: Int, $limit: Int) {
    userInvoices(offset: $offset, limit: $limit) {
      hasMore
      items {
        id
        type
        status
        invoiceNumber
        date
        dueDate
        company {
          id
          name
        }
        project {
          id
          name
        }
        total
        netTotal
        balance
        linkedResource {
          ... on TimesheetsAsLinkedResource {
            startDate
            endDate
            project {
              name
            }
          }
          ... on Order {
            id
            startDate
            endDate
            project {
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_OPENED_CREDIT_NOTES = gql`
  query getOpenedCreditNotes($offset: Int!, $limit: Int) {
    invoices(
      offset: $offset
      limit: $limit
      filter: { creditNotes: true, status: [sent, partially_paid] }
    ) {
      hasMore
      items {
        ...InvoiceFragment
        date
        company {
          id
          name
          client {
            id
            name
          }
        }
      }
    }
  }
  ${invoiceFragment}
`;

export const GET_OPENED_INVOICES = gql`
  query getOpenedInvoices(
    $offset: Int!
    $limit: Int
    $assignedToRole: [Role]
    $lateFilter: LateFilterOptions
    $assignedToUser: ID
    $collectionStatus: [InvoiceCollectionStatus]
    $client: ID
  ) {
    invoices(
      offset: $offset
      limit: $limit
      orderBy: due_date_desc
      filter: {
        creditNotes: false
        late: $lateFilter
        status: [sent, reminder_1, reminder_2, reminder_3]
        assignedToRole: $assignedToRole
        assignedToUser: $assignedToUser
        collectionStatus: $collectionStatus
        client: $client
      }
    ) {
      hasMore
      items {
        ...InvoiceFragment
        date
        dueDate
        promisedDate
        comment
        communication
        projectId
        company {
          id
          name
          client {
            id
            name
          }
        }
        assignedTo {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
  ${invoiceFragment}
`;
